module.exports = __webpack_public_path__ + "images/backgrounds/city/full.1bbbf09d491d444d207e.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/city/full.jpg
// module id = dKnU
// module chunks = 13